import styled from 'styled-components';
import { Select } from 'antd';
import { COLOR, FONT_SIZE, SPACING } from '../../../../constants/theme';

export const Field = styled.div`
  margin-bottom: ${SPACING.xl};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-size: ${FONT_SIZE.label};
  font-weight: 500;
  color: ${COLOR.text};
`;

export const RequiredMark = styled.span`
  margin-right: 2px;
  color: ${COLOR.error};
`;

export const FieldHint = styled.p`
  margin: 0 0 6px;
  font-size: ${FONT_SIZE.hint};
  line-height: 1.5;
  color: ${COLOR.textSecondary};
`;

export const TimezoneSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    height: 40px !important;
    align-items: center;
  }
`;
